/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import useUtils from './useUtils'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import TableSkeleton from '../../modules/skeleton/TableSkelton'
import Pagination from '../../modules/pagination/Pagination'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'

const AnnouncementList = ({className}) => {
  const {fetchAnnouncements, deleteAnnouncement, deleteBulkAnnouncements, onEdit} = useUtils()
  const [loading, setLoading] = useState(true)
  const [announcements, setAnnouncements] = useState()
  const [selected, setSelected] = useState([])
  const [type, setType] = useState('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  dispatch(setTitle('Announcement'))

  const getAnnouncements = async () => {
    try {
      setLoading(true)
      const offset = (page - 1) * limit
      const result = await fetchAnnouncements(limit, offset)
      setTotalPages(Math.ceil(result?.count / limit))
      setAnnouncements(result)
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = (id) => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const handleBulkDelete = () => {
    setSelectedId(null)
    setType('bulk')
    setModalVisible(true)
  }

  const confirmDelete = async () => {

    try {
      if(selectedId){
      setLoading(true)
      const result = await deleteAnnouncement(selectedId, limit, (page - 1) * limit)
      setAnnouncements(result)
    }else{
      setLoading(true)
      const result = await deleteBulkAnnouncements(selected, limit, (page - 1) * limit)
      setAnnouncements(result)
      setSelected([])
    }
    
    } catch (error) {
      console.error('Error deleting Announcement:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  useEffect(() => {
    console.log(selected)
  }, [selected])

  useEffect(() => {
    getAnnouncements()
  }, [limit, page])

  const handleEdit = async (id) => {
    const values = await onEdit(id)
    navigate('/announcementlist/editannouncement', {state: {values}})
  }

  if (loading) return <TableSkeleton />
  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <div className='d-flex align-items-center dlx-wrap gap-lg-10'>
          <h3 className='card-title align-items-start'>
            <span className=' mt-1 text-muted fs-7 '>{announcements?.count} Items</span>
          </h3>
        </div>
        <div className='card-toolbar gap-2'>
          {selected.length>0 && <span className='btn btn-sm btn-danger' onClick={handleBulkDelete}>Delete Selected</span>}

          <a
            onClick={() => navigate('/announcementlist/addannouncement')}
            className='btn btn-sm btn-light-primary'
          >
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add Announcement
          </a>
        </div>
      </div>
      <div className='card-body py-10'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th><div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input widget-9-check'
                            type='checkbox'
                            checked={announcements.records.every((item) => selected.includes(item.id))}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelected(announcements.records.map((item) => item.id))
                              } else {
                                setSelected([])
                              }
                            }}
                          />
                        </div></th>
                <th className='min-w-150px'>TITLE</th>
                <th className='min-w-250px'>DETAIL</th>
                <th className='min-w-50px'>TYPE</th>
                <th className='min-w-50px'>ICON</th>
                <th className='min-w-100px text-end'>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {announcements?.records &&
                announcements?.records.map((value, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input widget-9-check'
                            type='checkbox'
                            value={value?.id}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelected((prevSelected) => [...prevSelected, value.id])
                              } else {
                                setSelected((prevSelected) =>
                                  prevSelected.filter((id) => id !== value.id)
                                )
                              }
                            }}
                            checked={selected.includes(value.id)}
                          />
                        </div>
                      </td>
                      <td>
                        <a href='#' className='text-dark fw-bold  fs-6'>
                          {value?.title}
                        </a>
                      </td>
                      <td>
                        <a
                          href='#'
                          className='text-dark fw-bold  d-block mb-1 fs-6'
                        >
                          {value?.detail?.length > 40
                            ? value?.detail?.slice(0, 40) + ' ...'
                            : value?.detail}
                        </a>
                      </td>
                      <td>
                        <a
                          href='#'
                          className='text-dark fw-bold  d-block mb-1 fs-6'
                        >
                          {value?.type}
                        </a>
                      </td>
                      <td>
                        <a
                          href='#'
                          className='text-dark  fw-bold  d-block mb-1 fs-6'
                        >
                          <img
                            style={{height: '24px', width: '24px'}}
                            src={value?.announcementType?.imageUrl}
                          />
                        </a>
                      </td>

                      <td className='d-flex  justify-content-end'>
                        <a
                          onClick={() => handleEdit(value.id)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        >
                          <KTSVG
                            path='/media/icons/duotune/art/art005.svg'
                            className='svg-icon-3 svg-icon-primary'
                          />
                        </a>
                        <a
                          onClick={() => handleDelete(value.id)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-3 text-danger'
                          />
                        </a>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>

      <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
        <div className='d-flex align-items-center gap-3'>
          <span className='fs-6 text-muted'>Show</span>
          <div>
            <select
              defaultValue={limit}
              className='form-select form-select-solid text-muted select2-hidden-accessible'
              onChange={(e) => {
                setPage(1)
                setLimit(e.target.value)
              }}
            >
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
        </div>
        <DeleteConfirmation
          isVisible={modalVisible}
          message={type === 'bulk' ? 'Are you sure you want to delete selected announcements ?' : 'Are you sure you want to delete this announcement ?'}
          onConfirm={confirmDelete}
          onCancel={() => setModalVisible(false)}
        />
        <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
      </div>
      {/* begin::Body */}
    </div>
  )
}

export default AnnouncementList
